// Копейки -> человекочитаемые рубли
export function fmtKop(kop, opts = {}) {
  const rub = (kop || 0) / 100;
  const { short = false } = opts;
  if (short && Math.abs(rub) >= 1000) {
    if (Math.abs(rub) >= 1_000_000) return `${(rub / 1_000_000).toFixed(2)} млн ₽`;
    return `${(rub / 1000).toFixed(1)} тыс ₽`;
  }
  return `${rub.toLocaleString("ru-RU", { maximumFractionDigits: 0 })} ₽`;
}

export function fmtNum(n) {
  return (n || 0).toLocaleString("ru-RU");
}

export function fmtPct(v) {
  return `${(v || 0).toFixed(1)}%`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("ru-RU", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}
